import React, { useEffect, useState, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch, useSelector } from 'react-redux';
import { useDropzone } from 'react-dropzone';

import { servicioStartDelete, startNewServicio, startSaveServicio, startUploading } from '../../../../actions/servicios';
import { ArrowBackIcon, CategoriesIcon, ComplementaryServicesIcon, DurationIcon, EyeIcon, PrepayIcon, ProfesionalesIcon, SucursalesFilledIcon, TrashIcon, VariantesIcon } from '../../../../assets/svg/iconos';
import { SelectDuracion } from './SelectDuracion';
import { SelectSucursal } from './SelectSucursal';
import { newServicio, getServiceImage } from '../../../../helpers/helpers';
import { ModalEliminarServicio } from '../modales/ModalEliminarServicio';
import { openModalBottom } from '../../../../actions/ui';

import imagePlaceholder from '../../../../assets/img/service-image-placeholder.jpg';
import { SelectVariante } from './SelectVariante';
import { SelectComplementario } from './SelectComplementario';
import { SelectCategoria } from './SelectCategoria';
import { SelectProfesional } from './SelectProfesional';

export const Servicio = ({history}) => {

    const dispatch = useDispatch();
    const { colores, miniLateral } = useSelector( state => state.ui );
    const { empresa } = useSelector(state => state.auth);
    const { empresas } = useSelector(state => state.empresas);
    const { servicios } = useSelector(state => state.servicios);

    const [currentServicio, setCurrentServicio] = useState( history.location.state.servicio || null );
    const [currentScreen] = useState( (history.location.state.servicio) ? 'edit' : 'new' );

    const [objServicio, setObjServicio] = useState({});
    const [iniciado, setIniciado] = useState(false);
    const [cambiado, setCambiado] = useState(false);

    const [editMode, setEditMode] = useState(true);

    const [imageUrl, setImageUrl] = useState('');
    const [file, setFile] = useState(null);
    const [serviceImage, setServiceImage] = useState(null);
    
    const [idiomaActive, ] = useState('ES');
    const [objErrores, setObjErrores] = useState({});

    const [modalEliminarServicioOpened, setModalEliminarServicioOpened] = useState(false);
    const [dataModalEliminar, setDataModalEliminar] = useState({
        title: '¿Eliminar servicio?',
        text: [],
        buttonText: 'Eliminar',
        button2Text: 'Cancelar'
    });

    const [precio, setPrecio] = useState(0);
    const [precioReal, setPrecioReal] = useState(0);

    useEffect(() => {
      if( currentServicio ){
        setObjServicio( currentServicio );
        setPrecioInicial( currentServicio.precio );
        setIniciado( true );
        
        let sectorId = null;
        const empresaId = typeof empresa === 'string' ? empresa : empresa?._id;
        
        if (empresas && empresas.length > 0 && empresaId) {
            const empresaData = empresas.find(e => e._id === empresaId);
            if (empresaData && empresaData.sector) {
                sectorId = typeof empresaData.sector === 'string' ? empresaData.sector : empresaData.sector._id;
            }
        }
        
        const imagenServicio = getServiceImage(currentServicio, sectorId);
        
        if (imagenServicio && !imagenServicio.startsWith('/assets/')) {
            getImagenPrincipal(imagenServicio);
        }
      } else {
        setEditMode( true );
        setCambiado(true);
        const nuevo = newServicio( empresa );
        setCurrentServicio( nuevo );
        setObjServicio( nuevo );
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentServicio, empresas]);

    // useEffect(() => {
    //   console.log('serviceImage', serviceImage);
    //   console.log('imageUrl', imageUrl);
    // }, [serviceImage, imageUrl]);
    

    useEffect(() => {
        if( iniciado && currentServicio && currentServicio._id ){
            const servicioEnRedux = servicios.find( s => s._id === currentServicio._id );
            if( servicioEnRedux ){
                if( servicioEnRedux.complementarios ){
                    const complementariosActuales = objServicio.complementarios || [];
                    const complementariosEnRedux = servicioEnRedux.complementarios || [];
                    const complementariosCambiaron = complementariosActuales.length !== complementariosEnRedux.length ||
                        complementariosActuales.some( id => !complementariosEnRedux.includes( id ) ) ||
                        complementariosEnRedux.some( id => !complementariosActuales.includes( id ) );
                    
                    if( complementariosCambiaron && !cambiado ){
                        setObjServicio( prev => ({
                            ...prev,
                            complementarios: complementariosEnRedux
                        }) );
                        setCurrentServicio( servicioEnRedux );
                    }
                }
                
                if( servicioEnRedux.categorias ){
                    const categoriasActuales = objServicio.categorias || [];
                    const categoriasEnRedux = servicioEnRedux.categorias || [];
                    
                    const categoriasActualesStr = categoriasActuales.map(cat => 
                        typeof cat === 'object' && cat._id ? cat._id.toString() : cat.toString()
                    );
                    const categoriasEnReduxStr = categoriasEnRedux.map(cat => 
                        typeof cat === 'object' && cat._id ? cat._id.toString() : cat.toString()
                    );
                    
                    const categoriasCambiaron = categoriasActualesStr.length !== categoriasEnReduxStr.length ||
                        categoriasActualesStr.some( id => !categoriasEnReduxStr.includes( id ) ) ||
                        categoriasEnReduxStr.some( id => !categoriasActualesStr.includes( id ) );
                    
                    if( categoriasCambiaron && !cambiado ){
                        setObjServicio( prev => ({
                            ...prev,
                            categorias: categoriasEnRedux
                        }) );
                        setCurrentServicio( servicioEnRedux );
                    }
                }
                
                if( servicioEnRedux.profesionales ){
                    const profesionalesActuales = objServicio.profesionales || [];
                    const profesionalesEnRedux = servicioEnRedux.profesionales || [];
                    
                    const profesionalesActualesStr = profesionalesActuales.map(prof => 
                        typeof prof === 'object' && prof._id ? prof._id.toString() : prof.toString()
                    );
                    const profesionalesEnReduxStr = profesionalesEnRedux.map(prof => 
                        typeof prof === 'object' && prof._id ? prof._id.toString() : prof.toString()
                    );
                    
                    const profesionalesCambiaron = profesionalesActualesStr.length !== profesionalesEnReduxStr.length ||
                        profesionalesActualesStr.some( id => !profesionalesEnReduxStr.includes( id ) ) ||
                        profesionalesEnReduxStr.some( id => !profesionalesActualesStr.includes( id ) );
                    
                    if( profesionalesCambiaron && !cambiado ){
                        setObjServicio( prev => ({
                            ...prev,
                            profesionales: profesionalesEnRedux
                        }) );
                        setCurrentServicio( servicioEnRedux );
                    }
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [servicios, iniciado, currentServicio?._id]);

    useEffect(() => {
        // console.log( 'objServicio', objServicio );
        if( currentServicio ){
            const servicioOriginal = { ...currentServicio };
            if( iniciado ){
                let igual = true;
                for( const propiedad in servicioOriginal ){
                    //console.log( `${nEmpresa[propiedad]} !== ${objEmpresa[propiedad]}`)
                    if( servicioOriginal[propiedad] !== objServicio[propiedad] ){
                        igual = false;
                        // console.log(`Cambio en ${propiedad}`);
                    }
                }
                if( precioReal !== currentServicio.precio ){
                    igual = false;
                }
                setCambiado( !igual );
            }
        }
        if( serviceImage ){
            setCambiado( true );
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iniciado, currentServicio, objServicio, serviceImage, precioReal]);

    const backClick = () => {
        history.push({
            pathname: `/punto-venta/servicios`
        });
    }

    const setPrecioInicial = ( valor ) => {
        setPrecioReal( valor );
        const newValue = valor / 100;
        setPrecio(newValue);
    };

    const handlePrecioChange = (event) => {
        const newValue = event.target.value;
        setPrecioReal( Number(event.target.value) * 100 );
        if( newValue !== ''){
            setPrecio( Number(event.target.value) / 100 );
        } else {
            setPrecio(0);
        }
        setPrecio(newValue);
    };

    const guardar = async () => {
        // console.log( 'currentScreen', currentScreen );
        let correcto = true;
        const newObjErrores = {};
        if( objServicio.nombre.trim() === '' ){ 
            correcto = false;
            newObjErrores.nombre = 'Debes escribir un nombre';
        }

        if( objServicio.descripcion.trim() === '' ){ 
            correcto = false;
            newObjErrores.telefono = 'Debes escribir una descripción';
        }
        
        if( objServicio.sucursales.length <= 0 ){ 
            correcto = false;
            newObjErrores.sucursales = 'Debes seleccionar alguna sucursal';
        }
        
        //console.log( objServicio );
        //console.log('Correcto:', correcto );
        //console.log('Errores:', newObjErrores );
        setObjErrores( newObjErrores );
        let newObjeto = { ...objServicio, precio: precioReal };
        if( correcto ){
            //console.log('correcto');
            if( serviceImage ){
                let previa = '';
                if( currentServicio.img.length > 0) {
                    previa = currentServicio.img[0];
                }
                const imgName = `${objServicio._id}-${new Date().getTime()}`;
                const archivo = file;
                const nombreCortado = archivo.name.split('.');
                const extension = nombreCortado[ nombreCortado.length -1 ];
                const nombreCompleto = `${imgName}.${extension}`;

                newObjeto = { ...newObjeto, img: [nombreCompleto]};

                dispatch( startUploading( file, newObjeto, nombreCompleto, previa ) );
            }
            
            if( currentScreen === 'new' ){
                delete newObjeto._id;
                const newServicio = await dispatch( startNewServicio( newObjeto ) );
                console.log('newServicio returned:', newServicio);
                
                if( serviceImage ){
                    let previa = '';
                    if( currentServicio.img.length > 0) {
                        previa = currentServicio.img[0];
                    }
                    const imgName = `${newServicio._id}-${new Date().getTime()}`;
                    const archivo = file;
                    const nombreCortado = archivo.name.split('.');
                    const extension = nombreCortado[ nombreCortado.length -1 ];
                    const nombreCompleto = `${imgName}.${extension}`;

                    const servicioConImagen = { ...newServicio, img: [nombreCompleto]};
                    await dispatch( startUploading( file, servicioConImagen, nombreCompleto, previa ) );
                }
                
                history.push({ pathname: `/punto-venta/servicios` });
            } else {
                console.log( newObjeto );
                dispatch( startSaveServicio( newObjeto ) );
                setCambiado( false );
                /* setObjServicio( newObjeto );
                setCurrentServicio( newObjeto ); */
            }            
        } else {
            showModalErrores( newObjErrores );
        }
    }

    const showModalErrores = ( objErrores ) => {
        let arrayErrores = [];
        for (const key in objErrores) {
            arrayErrores = [ ...arrayErrores, objErrores[key] ];
        }
        //console.log( 'arrayErrores', arrayErrores );
        dispatch( openModalBottom({text: arrayErrores, timeOut: 5}) );
    }

    const cancelar = () => {
        if( currentScreen !== 'new' ){
            setPrecioReal( currentServicio.precio );
            setPrecio( currentServicio.precio / 100 );
            setObjServicio( currentServicio );
            setServiceImage(null);
            setFile(null);
        } else {
            history.goBack();
        }
    }
    
    const onFormChange = (e) => {
        console.log( e.target.value );
        let correcto = true;
        if( e.target.name === 'precio' ){
            const validNumber = new RegExp(/^\d*\.?\d*$/);
            if( !validNumber.test( e.target.value ) ){
                correcto = false;
            }
        }
        if( correcto ){
            dataChange( e.target.name, e.target.value );
        }
    }

    const dataChange = (name, value) => {
        if( editMode ){
            setObjServicio({
                ...objServicio,
                [name]: value
            });
        } else {
            dispatch( openModalBottom({text: ['Debes activar la edición para poder realizar cambios'], timeOut: 3}) );
        }
    }
    
    const getImagenPrincipal = async( nombre ) => {
        setImageUrl( { url: nombre} );
    }

    const onDrop = useCallback( (acceptedFiles) => {
        // console.log( 'onDrop' );
        // console.log( 'objServicio', objServicio );
        // console.log( acceptedFiles );

        // dispatch( startUploading( acceptedFiles[0], objServicio._id, objServicio.empresa ));
        const file = acceptedFiles[0];
        setFile(file);
        setServiceImage(URL.createObjectURL(file));
        
        //dispatch( startUploading( file, objServicio ) );
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [objServicio]);

    const { getRootProps, getInputProps } = useDropzone({
        accept: "image/jpeg, image/png",
        noKeyboard: true,
        onDrop
    });

    const deleteServicioModal = () => {
        setDataModalEliminar({
            ...dataModalEliminar,
            text: [`¿Estás seguro de que deseas eliminar a ${objServicio.nombre}?`]
        })
        setModalEliminarServicioOpened( true );
    };

    const deleteServicioResponse = ( value ) => {
        if( value === 1 ){
          //console.log( 'value = 1' );
          let selectedId = objServicio._id;

          //console.log( 'Borrar id:', selectedId );
          dispatch( servicioStartDelete( selectedId, empresa ) );
          history.push({ pathname: `/punto-venta/servicios` })
        }
    }

    return (
        <>
        <div 
            className='servicio'
            style={{
                '--colorPrincipal': colores.colorPrincipal,
                '--colorSecundario': colores.colorSecundario,
                '--color3': colores.color3,
                '--color4': colores.color4,
                '--color5': colores.color5,
                '--color6': colores.color6,
                '--color7': colores.color7,
            }}
        >
            <div className='servicio-wrapper'>
                <div className='single-servicio'>
                    <div className={`header ${!miniLateral && 'compress'}`}>
                        <div 
                            className='nav-back'
                            onClick={ backClick }
                        >
                            <ArrowBackIcon color={ colores.colorSecundario } />
                            <p style={{ color: colores.colorSecundario }}>Servicios</p>
                        </div>
                        <div className='botonera'>
                            {/* {
                                !cambiado &&
                                <button
                                    className='btn-mini btn-editar'
                                    style={{ backgroundColor: editMode ? colores.colorPrincipal : colores.color6 }}
                                    onClick={ () => setEditMode( !editMode ) }
                                >
                                    <EditarIcon color={ editMode ? colores.color6 : colores.colorPrincipal } />
                                </button>
                            } */}
                            {
                                !cambiado &&
                                <button
                                    className='btn-mini btn-eliminar'
                                    style={{ backgroundColor: colores.color6 }}
                                    onClick={ deleteServicioModal }
                                >
                                    <TrashIcon color={ colores.colorPrincipal } />
                                </button>
                            }
                            {
                            cambiado &&
                                <button 
                                    className='btn btn-crear'
                                    style={{ backgroundColor: colores.colorPrincipal }}
                                    onClick={ guardar }
                                >
                                    {`${currentScreen === 'new' ? 'Crear' : 'Guardar'}`}
                                </button>
                            }
                            {
                            cambiado &&
                                <button 
                                    className='btn btn-cancelar'
                                    style={{ color: colores.colorPrincipal, backgroundColor: colores.color6 }}
                                    onClick={ cancelar }
                                >
                                    Cancelar
                                </button>
                            }
                        </div>
                        
                    </div>
                    <div className='name'>
                        <input
                            style={{ 
                                backgroundColor: editMode ? '#ffffff' : 'transparent',
                                border: `${objErrores.nombre ? '2px solid ' + colores.color5 : 'none'}`
                            }}
                            autoComplete='off'
                            type="text"
                            placeholder='Nuevo servicio'
                            name="nombre"
                            disabled={ !editMode }
                            value={ objServicio.nombre || '' }
                            onChange={ (e) => onFormChange( e )}
                        />
                    </div>
                    <div className='servicio-main'>
                        <div className='servicio-left'>
                            <div
                                {...getRootProps({className: 'dropzone image-container'})}
                                style={{ 
                                    backgroundImage: `url(${
                                        serviceImage 
                                            ? serviceImage 
                                            : (imageUrl.url 
                                                ? imageUrl.url + '?' + uuidv4() 
                                                : (() => {
                                                    let sectorId = null;
                                                    const empresaId = typeof empresa === 'string' ? empresa : empresa?._id;
                                                    if (empresas && empresas.length > 0 && empresaId) {
                                                        const empresaData = empresas.find(e => e._id === empresaId);
                                                        if (empresaData && empresaData.sector) {
                                                            sectorId = typeof empresaData.sector === 'string' ? empresaData.sector : empresaData.sector._id;
                                                        }
                                                    }
                                                    return getServiceImage(objServicio, sectorId) || imagePlaceholder;
                                                })())
                                    })`
                                }}
                            >
                                <input {...getInputProps()} />
                            </div>
                        </div>
                        <div className='servicio-right'>
                            <div className='servicio-data'>
                                <div className='servicio-texts'>
                                    <div className='servicio-text'>
                                        <h3 style={{ color: colores.colorSecundario }}>Descripción</h3>
                                        <textarea
                                            style={{ 
                                                backgroundColor: editMode ? '#f7f7f7' : 'transparent',
                                                border: `${objErrores.nombre ? '2px solid ' + colores.color5 : 'none'}`
                                            }}
                                            name="descripcion"
                                            placeholder='Añadir descripción'
                                            disabled={ !editMode }
                                            value={ objServicio.descripcion }
                                            onChange={ (e) => onFormChange( e )}
                                        ></textarea>
                                        <div className='idiomas'>
                                            <div 
                                                className='btn-idioma'
                                                style={{ backgroundColor: idiomaActive === 'ES' ? colores.colorPrincipal : colores.colorSecundario}}
                                            >ES</div>
                                            <div 
                                                className='btn-idioma'
                                                style={{ backgroundColor: idiomaActive === 'CT' ? colores.colorPrincipal : colores.colorSecundario}}
                                            >CT</div>
                                        </div>
                                    </div>
                                    <div className='servicio-text condiciones'>
                                        <h3 style={{ color: colores.colorSecundario }}>Condiciones</h3>
                                        <textarea
                                            style={{ 
                                                backgroundColor: editMode ? '#f7f7f7' : 'transparent',
                                                border: `${objErrores.nombre ? '2px solid ' + colores.color5 : 'none'}`
                                            }}
                                            name="condiciones"
                                            placeholder='Añadir condiciones'
                                            disabled={ !editMode }
                                            value={ objServicio.condiciones }
                                            onChange={ (e) => onFormChange( e )}
                                        ></textarea>
                                        <div className='idiomas'>
                                            <div 
                                                className='btn-idioma'
                                                style={{ backgroundColor: idiomaActive === 'ES' ? colores.colorPrincipal : colores.colorSecundario}}
                                            >ES</div>
                                            <div 
                                                className='btn-idioma'
                                                style={{ backgroundColor: idiomaActive === 'CT' ? colores.colorPrincipal : colores.colorSecundario}}
                                            >CT</div>
                                        </div>
                                    </div>
                                </div>
                                <div className='servicio-price'>
                                    <div 
                                        className='price-item'
                                        style={{ color: colores.colorPrincipal, backgroundColor: colores.colorSecundario }}
                                    >
                                        {/* <AutosizeInput
                                            inputStyle={{ 
                                                color: colores.colorPrincipal,
                                                fontSize: precio.length > 2 ? '25px' : '30px'
                                            }}
                                            autoComplete='off'
                                            type="number"
                                            placeholder='--'
                                            name="precio"
                                            disabled={ !editMode }
                                            value={ precio }
                                            onChange={ handlePrecioChange }
                                        /> */}
                                        <input 
                                            style={{ 
                                                color: colores.colorPrincipal,
                                                fontSize: precio.length > 2 ? '25px' : '30px'
                                            }}
                                            autoComplete='off'
                                            type="number"
                                            placeholder='--'
                                            name="precio"
                                            disabled={ !editMode }
                                            value={ precio }
                                            onChange={ handlePrecioChange }
                                        />
                                        <span
                                            style={{
                                                fontSize: precio.length > 2 ? '25px' : '30px'
                                            }}
                                        >€</span>
                                    </div>
                                </div>
                            </div>
                            <div className='servicio-selectors'>
                                <div 
                                    className='servicio-selector'
                                    style={{ 
                                        backgroundColor: colores.colorSecundario,
                                        border: `${objErrores.sucursales ? '2px solid ' + colores.color5 : 'none'}`
                                    }}
                                >
                                    <div className='left'>
                                        <div className='icon-bg'>
                                            <SucursalesFilledIcon color={ colores.colorPrincipal }/>
                                        </div>
                                    </div>
                                    <div className='right'>
                                        <div className='title' style={{ color: colores.colorPrincipal }}>Sucursales</div>
                                        <SelectSucursal
                                            editMode={ editMode }
                                            objServicio={ objServicio }
                                            dataChange={ dataChange }
                                            big={ true }
                                        />
                                    </div>
                                </div>
                                <div
                                    className='servicio-selector pauses'
                                    style={{ backgroundColor: colores.colorSecundario }}
                                >
                                    <div className='left'>
                                        <div className='icon-bg'>
                                            <DurationIcon color={ colores.colorPrincipal }/>
                                        </div>
                                    </div>
                                    <div className='right select-duracion'>
                                        <SelectDuracion 
                                            editMode={ editMode }
                                            objServicio={ objServicio }
                                            setObjServicio={ setObjServicio }
                                            dataChange={ dataChange }
                                        />
                                        
                                    </div>
                                </div>
                                <div
                                    className='servicio-selector'
                                    style={{ backgroundColor: colores.colorSecundario }}
                                >
                                    <div className='left'>
                                        <div className='icon-bg'>
                                            <ComplementaryServicesIcon color={ colores.colorPrincipal }/>
                                        </div>
                                    </div>
                                    <div className='right'>
                                        <div className='title' style={{ color: colores.colorPrincipal }}>Servicios complementarios</div>
                                        <SelectComplementario
                                            editMode={ editMode }
                                            objServicio={ objServicio }
                                            dataChange={ dataChange }
                                            big={ true }
                                        />
                                    </div>
                                </div>
                                <div 
                                    className='servicio-selector'
                                    style={{ backgroundColor: colores.colorSecundario }}
                                >
                                    <div className='left'>
                                        <div className='icon-bg'>
                                            <VariantesIcon color={ colores.colorPrincipal }/>
                                        </div>
                                    </div>
                                    <div className='right'>
                                        <div className='title' style={{ color: colores.colorPrincipal }}>Variantes</div>
                                        <SelectVariante
                                            editMode={ editMode }
                                            objServicio={ objServicio }
                                            dataChange={ dataChange }
                                            big={ true }
                                            top={ true }
                                            left={ true }
                                        />
                                    </div>
                                </div>
                                {
                                    objServicio.variantes && objServicio.variantes.length > 0 &&
                                    <div
                                        className='servicio-selector variante-obligatoria'
                                        style={{ backgroundColor: `${objServicio.varianteObligatoria ? colores.colorSecundario : '#F7F7F7'}`}}
                                    >
                                        <div className='left'>
                                            <div className='icon-bg'>
                                                <VariantesIcon color={ `${objServicio.varianteObligatoria ? colores.colorPrincipal : '#7B7B7B'}` }/>
                                            </div>
                                        </div>
                                        <div className='right'>
                                            <div 
                                                className={ `ylm-toggle ${ objServicio.varianteObligatoria && 'active'}`}
                                                onClick={ () => {
                                                    if (editMode) {
                                                        const newValue = !objServicio.varianteObligatoria;
                                                        dataChange('varianteObligatoria', newValue);
                                                        // Si se desactiva varianteObligatoria, también desactivar sinVariante
                                                        if (!newValue && objServicio.sinVariante) {
                                                            dataChange('sinVariante', false);
                                                        }
                                                    }
                                                }}
                                            >
                                                <p style={{ color: objServicio.varianteObligatoria ? colores.colorPrincipal: '#707070' }}>{ `OBLIGATORIA` }</p>
                                                <div 
                                                    className={ `toggle-bg`}
                                                    style={{ backgroundColor: objServicio.varianteObligatoria ? '#FFFFFF' : '#C9C5C5' }}
                                                >
                                                    <span
                                                        className={`toggle-item`}
                                                        style={{ backgroundColor: objServicio.varianteObligatoria ? colores.colorPrincipal : '#7B7B7B' }}
                                                    ></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {
                                    objServicio.variantes && objServicio.variantes.length > 0 && objServicio.varianteObligatoria &&
                                    <div
                                        className='servicio-selector sin-variante'
                                        style={{ backgroundColor: `${objServicio.sinVariante ? colores.colorSecundario : '#F7F7F7'}`}}
                                    >
                                        <div className='left'>
                                            <div className='icon-bg'>
                                                <VariantesIcon color={ `${objServicio.sinVariante ? colores.colorPrincipal : '#7B7B7B'}` }/>
                                            </div>
                                        </div>
                                        <div className='right'>
                                            <div 
                                                className={ `ylm-toggle ${ objServicio.sinVariante && 'active'}`}
                                                onClick={ () => editMode && dataChange( 'sinVariante', !objServicio.sinVariante )}
                                            >
                                                <p style={{ color: objServicio.sinVariante ? colores.colorPrincipal: '#707070' }}>{ `SIN VARIANTE` }</p>
                                                <div 
                                                    className={ `toggle-bg`}
                                                    style={{ backgroundColor: objServicio.sinVariante ? '#FFFFFF' : '#C9C5C5' }}
                                                >
                                                    <span
                                                        className={`toggle-item`}
                                                        style={{ backgroundColor: objServicio.sinVariante ? colores.colorPrincipal : '#7B7B7B' }}
                                                    ></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div
                                    className='servicio-selector overbooking-5min'
                                    style={{ backgroundColor: `${(objServicio.overbookingMinutos || 0) > 0 ? colores.colorSecundario : '#F7F7F7'}`}}
                                >
                                    <div className='left'>
                                        <div className='icon-bg'>
                                            <DurationIcon color={ (objServicio.overbookingMinutos || 0) > 0 ? colores.colorPrincipal : '#7B7B7B' }/>
                                        </div>
                                    </div>
                                    <div className='right'>
                                        <div
                                            className={ `ylm-toggle ${ (objServicio.overbookingMinutos || 0) > 0 && 'active'}`}
                                            onClick={ () => editMode && dataChange('overbookingMinutos', (objServicio.overbookingMinutos || 0) > 0 ? 0 : 5) }
                                        >
                                            <p style={{ color: (objServicio.overbookingMinutos || 0) > 0 ? colores.colorPrincipal : '#707070' }}>5MIN OVERBOOKING</p>
                                            <div
                                                className='toggle-bg'
                                                style={{ backgroundColor: (objServicio.overbookingMinutos || 0) > 0 ? '#FFFFFF' : '#C9C5C5' }}
                                            >
                                                <span
                                                    className='toggle-item'
                                                    style={{ backgroundColor: (objServicio.overbookingMinutos || 0) > 0 ? colores.colorPrincipal : '#7B7B7B' }}
                                                ></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className='servicio-selector'
                                    style={{ backgroundColor: colores.colorSecundario }}
                                >
                                    <div className='left'>
                                        <div className='icon-bg'>
                                            <CategoriesIcon color={ colores.colorPrincipal }/>
                                        </div>
                                    </div>
                                    <div className='right'>
                                        <div className='title' style={{ color: colores.colorPrincipal }}>Categorías</div>
                                        <SelectCategoria
                                            editMode={ editMode }
                                            objServicio={ objServicio }
                                            dataChange={ dataChange }
                                            big={ true }
                                            top={ true }
                                            left={ true }
                                        />
                                    </div>
                                </div>
                                <div 
                                    className='servicio-selector'
                                    style={{ backgroundColor: colores.colorSecundario }}
                                >
                                    <div className='left'>
                                        <div className='icon-bg'>
                                            <ProfesionalesIcon color={ colores.colorPrincipal }/>
                                        </div>
                                    </div>
                                    <div className='right'>
                                        <div className='title' style={{ color: colores.colorPrincipal }}>Profesionales</div>
                                        <SelectProfesional
                                            editMode={ editMode }
                                            objServicio={ objServicio }
                                            dataChange={ dataChange }
                                            big={ true }
                                            top={ true }
                                            left={ true }
                                        />
                                    </div>
                                </div>
                                <div
                                    className='servicio-selector prepago'
                                    //style={{ backgroundColor: `#F7F7F7` }}
                                    style={{ backgroundColor: `${objServicio.prepago ? colores.colorSecundario : '#F7F7F7'}`}}
                                >
                                    <div className='left'>
                                        <div className='icon-bg'>
                                            <PrepayIcon color={ `${objServicio.prepago ? colores.colorPrincipal : '#7B7B7B'}` }/>
                                        </div>
                                    </div>
                                    <div className='right'>
                                        <div 
                                            className={ `ylm-toggle ${ objServicio.prepago && 'active'}`}
                                            onClick={ () => editMode && dataChange( 'prepago', !objServicio.prepago )}
                                        >
                                            <p style={{ color: objServicio.prepago ? colores.colorPrincipal: '#707070' }}>{ `Prepago` }</p>
                                            <div 
                                                className={ `toggle-bg`}
                                                style={{ backgroundColor: objServicio.prepago ? '#FFFFFF' : '#C9C5C5' }}
                                            >
                                                <span
                                                    className={`toggle-item`}
                                                    style={{ backgroundColor: objServicio.prepago ? colores.colorPrincipal : '#7B7B7B' }}
                                                ></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className='servicio-selector visible-en-app'
                                    style={{ backgroundColor: `${objServicio.visibleEnApp ? colores.colorSecundario : '#F7F7F7'}`}}
                                >
                                    <div className='left'>
                                        <div className='icon-bg'>
                                            <EyeIcon color={ `${objServicio.visibleEnApp ? colores.colorPrincipal : '#7B7B7B'}` }/>
                                        </div>
                                    </div>
                                    <div className='right'>
                                        <div 
                                            className={ `ylm-toggle ${ objServicio.visibleEnApp && 'active'}`}
                                            onClick={ () => editMode && dataChange( 'visibleEnApp', !objServicio.visibleEnApp )}
                                        >
                                            <p style={{ color: objServicio.visibleEnApp ? colores.colorPrincipal: '#707070' }}>{ `VISIBLE EN APP` }</p>
                                            <div 
                                                className={ `toggle-bg`}
                                                style={{ backgroundColor: objServicio.visibleEnApp ? '#FFFFFF' : '#C9C5C5' }}
                                            >
                                                <span
                                                    className={`toggle-item`}
                                                    style={{ backgroundColor: objServicio.visibleEnApp ? colores.colorPrincipal : '#7B7B7B' }}
                                                ></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalEliminarServicio
            data = { dataModalEliminar }
            setModalResponse = { deleteServicioResponse }
            modalOpened = { modalEliminarServicioOpened }
            setModalOpened = { setModalEliminarServicioOpened }
        />
        </>
    )
}
